// unlockTherapistService

import useAxiosInterceptor from 'src/services/interceptor';
class UnlockTherapistService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getUnlockTherapist = (payload: any) => {
    return this.axiosInstance.get(`/provider/daily-notes/notes-for-dor`, {
      params: payload,
    });
  };
  getLockDailySessionNote = (payload: any) => {
    return this.axiosInstance.get(`/provider/daily-notes/note-for-other`, {
      params: payload?.param,
    });
  };

  updateUnlockTherapist = (payload: any) => {
    return this.axiosInstance.put('/provider/daily-notes/unlock-note', payload?.data, {
      params: payload?.param,
    });
  };
}

const unlockTherapistService = new UnlockTherapistService();

Object.freeze(unlockTherapistService);

export default unlockTherapistService;
